
import React from 'react';

const Addresses = () => {

    return (
        <div>
            <div className="pt-8">
                <div className="flex items-center w-full pb-5">
                    <h2 className="text-base font-medium text-primary-0 font-redhat">Addresses</h2>
                    <div className="relative flex-grow ml-4 border-b border-gray-100 top-2"></div>
                </div>
            </div>
        </div>
    )
}

export default Addresses;